function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["title", "titleTag", "description", "descriptionMaxLines", "linkProps", "imagePosition", "imageSrc", "imageProps", "label", "children", "dateText", "isFullHeight", "isPush", "hasBodySpaceBetween", "hasBigTitle", "isDark", "className", "titleMaxLines"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import { bool, elementType, node, number, oneOf, shape, string } from "prop-types";
import classNamesMaker from "classnames";
import { Text, TEXT_COLORS, TEXT_TYPES } from "#library/components/Text/Text";
import { Signature } from "#library/components/Signature/Signature";
import { Card } from "#library/components/Card";
import { buildSlots } from "#library/utils/slots";
import styles from "./articleCard.module.css";
export var ARTICLE_IMAGE_POSITION = {
  TOP: "top",
  LEFT: "left",
  RIGHT: "right"
};
var ALLOWED_SLOTS = {
  SIGNATURE: "Signature"
};
export var ArticleCard = function ArticleCard(props) {
  var title = props.title,
    titleTag = props.titleTag,
    description = props.description,
    descriptionMaxLines = props.descriptionMaxLines,
    linkProps = props.linkProps,
    imagePosition = props.imagePosition,
    imageSrc = props.imageSrc,
    imageProps = props.imageProps,
    label = props.label,
    children = props.children,
    dateText = props.dateText,
    isFullHeight = props.isFullHeight,
    isPush = props.isPush,
    hasBodySpaceBetween = props.hasBodySpaceBetween,
    hasBigTitle = props.hasBigTitle,
    isDark = props.isDark,
    className = props.className,
    titleMaxLines = props.titleMaxLines,
    restProps = _objectWithoutProperties(props, _excluded);
  var _buildSlots = buildSlots(children, Object.values(ALLOWED_SLOTS)),
    SignatureSlot = _buildSlots.SignatureSlot;
  var classNames = classNamesMaker(_defineProperty({}, styles["jds-ArticleCard--push"], isPush), _defineProperty({}, styles["jds-ArticleCard--dark"], isDark), className);
  var leftAsideClassNames = classNamesMaker(styles["jds-ArticleCard__aside"], styles["jds-ArticleCard__asideLeft"]);
  var rightAsideClassNames = classNamesMaker(styles["jds-ArticleCard__aside"], styles["jds-ArticleCard__asideRight"]);
  var customTitleClassNames = classNamesMaker(_defineProperty({}, styles["jds-ArticleCard__title--maxLines"], titleMaxLines));
  var customDescriptionClassNames = classNamesMaker(_defineProperty({}, styles["jds-ArticleCard__description--maxLines"], descriptionMaxLines));
  var bodyCardClassName = classNamesMaker(_defineProperty({}, styles["jds-ArticleCard__body"], hasBodySpaceBetween));
  return /*#__PURE__*/React.createElement(Card, _extends({
    isDark: isDark,
    isFullHeight: isFullHeight,
    className: classNames
  }, restProps), /*#__PURE__*/React.createElement("div", {
    className: styles["jds-ArticleCard__wrapper"]
  }, imageSrc && imagePosition === ARTICLE_IMAGE_POSITION.TOP && /*#__PURE__*/React.createElement(Card.Header, {
    hasPadding: false
  }, /*#__PURE__*/React.createElement(Card.Image, {
    src: imageSrc,
    imageProps: imageProps
  })), imageSrc && imagePosition === ARTICLE_IMAGE_POSITION.LEFT && /*#__PURE__*/React.createElement(Card.Aside, {
    hasPadding: false,
    className: leftAsideClassNames
  }, /*#__PURE__*/React.createElement(Card.Image, {
    src: imageSrc,
    imageProps: imageProps
  })), /*#__PURE__*/React.createElement(Card.Body, {
    className: bodyCardClassName
  }, /*#__PURE__*/React.createElement("div", null, label && /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    type: TEXT_TYPES.LABEL,
    color: isDark ? TEXT_COLORS.GREY_LIGHT : TEXT_COLORS.GREY
  }, label), /*#__PURE__*/React.createElement(Card.Title, {
    resetSpacing: true,
    isBig: hasBigTitle,
    as: titleTag,
    linkProps: linkProps,
    className: customTitleClassNames,
    style: titleMaxLines ? {
      "--lineNumber": titleMaxLines
    } : undefined
  }, title), /*#__PURE__*/React.createElement(Text, {
    resetSpacing: true,
    className: customDescriptionClassNames,
    style: descriptionMaxLines ? {
      "--lineNumber": descriptionMaxLines
    } : undefined
  }, description)), (SignatureSlot || dateText) && !isPush && /*#__PURE__*/React.createElement(Card.SpaceBetween, null, SignatureSlot, /*#__PURE__*/React.createElement(Card.Time, {
    hasDarkBackground: isDark
  }, dateText))), imageSrc && imagePosition === ARTICLE_IMAGE_POSITION.RIGHT && /*#__PURE__*/React.createElement(Card.Aside, {
    hasPadding: false,
    className: rightAsideClassNames
  }, /*#__PURE__*/React.createElement(Card.Image, {
    src: imageSrc,
    imageProps: imageProps
  }))), (SignatureSlot || dateText) && isPush && /*#__PURE__*/React.createElement(Card.Footer, {
    hasDivider: false
  }, /*#__PURE__*/React.createElement(Card.SpaceBetween, {
    removeSpacing: true
  }, SignatureSlot, /*#__PURE__*/React.createElement(Card.Time, {
    hasDarkBackground: isDark
  }, dateText))));
};
ArticleCard.propTypes = {
  title: string.isRequired,
  titleTag: elementType,
  description: string.isRequired,
  linkProps: shape({}).isRequired,
  imagePosition: oneOf(Object.values(ARTICLE_IMAGE_POSITION)),
  imageSrc: string,
  imageProps: shape({
    component: elementType
  }),
  label: string,
  children: node,
  dateText: string,
  isFullHeight: bool,
  isPush: bool,
  hasBodySpaceBetween: bool,
  hasBigTitle: bool,
  isDark: bool,
  className: string,
  titleMaxLines: number,
  descriptionMaxLines: number
};
ArticleCard.defaultProps = {
  titleTag: "p",
  imagePosition: null,
  imageSrc: null,
  label: null,
  children: null,
  dateText: null,
  imageProps: {},
  isFullHeight: false,
  isPush: false,
  hasBodySpaceBetween: false,
  hasBigTitle: false,
  isDark: false,
  className: null,
  titleMaxLines: null,
  descriptionMaxLines: null
};
ArticleCard.Signature = Signature;
ArticleCard.Signature.slotName = ALLOWED_SLOTS.SIGNATURE;